export const WEBSITE = 'https://laurencebelzile.com';
export const LANDING = '/';
export const WORK = '/work';
export const EXHIBITIONS = '/exhibitions';
export const ABOUT = '/info';
export const CV = '/cv';
export const CONTACT = '/contact';
export const PROJECT_BASE = '/projet';
export const PROJECT = `${PROJECT_BASE}/:id`;
